function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React, { useState, useCallback, useMemo } from 'react';
import { Form, InputGroup, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { ChangeHighlighter, FormattedNumberInput } from '@rd-web-markets/shared/dist/util';
import ChangeHighlightedImmutableUnderReviewControl from '@rd-web-markets/shared/dist/util/reviewEditControls/ChangeHighlightedImmutableUnderReviewControl';
export const StaffingCostsRow = _ref => {
  let {
    index,
    claim,
    claimEmployees,
    setClaimEmployees,
    refreshClaim,
    claimEmployeesService,
    handleError
  } = _ref;
  const claimEmployee = useMemo(() => {
    return _objectSpread({}, claimEmployees[index]);
  }, [claimEmployees, index]);
  const [hasError, setHasError] = useState(false);
  const dispatch = useDispatch();
  const user = useSelector(state => state.auth.user);
  const updateEmployees = useCallback(employee => {
    const newEmployees = [...claimEmployees];
    newEmployees[index] = _objectSpread({}, employee);
    setClaimEmployees([...newEmployees]);
  }, [claimEmployees, index, setClaimEmployees]);
  const handleChange = useCallback(async event => {
    const value = event.target.type === 'checkbox' ? event.target.checked : event.target.value;
    claimEmployee[event.target.name] = value;
    await updateEmployees(claimEmployee);
  }, [updateEmployees, claimEmployee]);
  const saveChange = useCallback(() => {
    let method;
    if (claimEmployee.id) {
      method = 'update';
    } else {
      method = 'create';
    }
    claimEmployeesService[method](claimEmployee).then(updatedEmployee => {
      setHasError(false);
      updateEmployees(updatedEmployee);
      refreshClaim();
    }).catch(e => {
      setHasError(true);
      dispatch(handleError(e));
    });
  }, [claimEmployee, claimEmployeesService, updateEmployees, refreshClaim, dispatch, handleError]);
  const hasPermissions = () => {
    return user.account_type !== 'customer' && user.account_type !== 'accountant';
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("tr", {
    className: hasError ? 'bg-warning' : ''
  }, /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement("small", null, /*#__PURE__*/React.createElement("strong", null, claimEmployee.name), /*#__PURE__*/React.createElement("div", {
    className: "text-muted"
  }, claimEmployee.role ? "".concat(claimEmployee.role) : null))), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(ChangeHighlightedImmutableUnderReviewControl, {
    as: FormattedNumberInput,
    onChange: e => handleChange(e, index),
    onBlur: saveChange,
    object: _objectSpread(_objectSpread({}, claimEmployee), {}, {
      claim: _objectSpread(_objectSpread({}, claim), claimEmployee.claim)
    }),
    disabled: claim.financials_locked || !hasPermissions(),
    name: "base_salary",
    type: "text",
    size: "sm"
  })), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(ChangeHighlightedImmutableUnderReviewControl, {
    as: FormattedNumberInput,
    onChange: e => handleChange(e, index),
    onBlur: saveChange,
    object: _objectSpread(_objectSpread({}, claimEmployee), {}, {
      claim: _objectSpread(_objectSpread({}, claim), claimEmployee.claim)
    }),
    disabled: claim.financials_locked || !hasPermissions(),
    name: "bonus",
    type: "text",
    size: "sm"
  })), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement("div", {
    className: "d-flex"
  }, /*#__PURE__*/React.createElement(OverlayTrigger, {
    key: 'bottom',
    placement: 'bottom',
    overlay: /*#__PURE__*/React.createElement(Tooltip, {
      className: "tooltip-wide"
    }, "This is the ER NI override checkbox, if you unselected it the amount will be reset to 0 and you will have to manually add the ER NI rate")
  }, /*#__PURE__*/React.createElement(ChangeHighlightedImmutableUnderReviewControl, {
    as: Form.Check,
    object: _objectSpread(_objectSpread({}, claimEmployee), {}, {
      claim: _objectSpread(_objectSpread({}, claim), claimEmployee.claim)
    }),
    disabled: claim.financials_locked || !hasPermissions(),
    name: "override_national_insurance",
    onChange: async e => {
      await handleChange(e, index);
      saveChange();
    },
    size: "sm"
  })), /*#__PURE__*/React.createElement(ChangeHighlightedImmutableUnderReviewControl, {
    as: FormattedNumberInput,
    onChange: e => handleChange(e, index),
    onBlur: saveChange,
    object: _objectSpread(_objectSpread({}, claimEmployee), {}, {
      claim: _objectSpread(_objectSpread({}, claim), claimEmployee.claim)
    }),
    disabled: claim.financials_locked || !claimEmployee.override_national_insurance || !hasPermissions(),
    className: "ms-2",
    name: "national_insurance",
    type: "text",
    size: "sm"
  }))), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(ChangeHighlightedImmutableUnderReviewControl, {
    as: FormattedNumberInput,
    onChange: e => handleChange(e, index),
    onBlur: saveChange,
    object: _objectSpread(_objectSpread({}, claimEmployee), {}, {
      claim: _objectSpread(_objectSpread({}, claim), claimEmployee.claim)
    }),
    disabled: claim.financials_locked || !hasPermissions(),
    name: "pension",
    type: "text",
    size: "sm"
  })), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(ChangeHighlightedImmutableUnderReviewControl, {
    as: FormattedNumberInput,
    onBlur: saveChange,
    onChange: e => handleChange(e, index),
    object: _objectSpread(_objectSpread({}, claimEmployee), {}, {
      claim: _objectSpread(_objectSpread({}, claim), claimEmployee.claim)
    }),
    disabled: claim.financials_locked || !hasPermissions(),
    name: "reimbursed_expenses",
    type: "text",
    size: "sm"
  })), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(ChangeHighlightedImmutableUnderReviewControl, {
    as: FormattedNumberInput,
    object: _objectSpread(_objectSpread({}, claimEmployee), {}, {
      claim: _objectSpread(_objectSpread({}, claim), claimEmployee.claim)
    }),
    onBlur: saveChange,
    disabled: true,
    name: "net_amount",
    type: "text",
    size: "sm"
  })), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(ChangeHighlightedImmutableUnderReviewControl, {
    as: FormattedNumberInput,
    onChange: e => handleChange(e, index),
    onBlur: saveChange,
    object: _objectSpread(_objectSpread({}, claimEmployee), {}, {
      claim: _objectSpread(_objectSpread({}, claim), claimEmployee.claim)
    }),
    disabled: claim.financials_locked || !hasPermissions(),
    name: "capitalised_amount",
    type: "text",
    size: "sm"
  })), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(ChangeHighlightedImmutableUnderReviewControl, {
    as: FormattedNumberInput,
    object: _objectSpread(_objectSpread({}, claimEmployee), {}, {
      claim: _objectSpread(_objectSpread({}, claim), claimEmployee.claim)
    }),
    disabled: true,
    name: "rnd_amount",
    type: "text",
    size: "sm"
  })), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(ChangeHighlightedImmutableUnderReviewControl, {
    as: FormattedNumberInput,
    object: _objectSpread(_objectSpread({}, claimEmployee), {}, {
      claim: _objectSpread(_objectSpread({}, claim), claimEmployee.claim)
    }),
    disabled: true,
    name: "pnl_expenditure",
    type: "text",
    size: "sm"
  })), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(ChangeHighlightedImmutableUnderReviewControl, {
    as: FormattedNumberInput,
    object: _objectSpread(_objectSpread({}, claimEmployee), {}, {
      claim: _objectSpread(_objectSpread({}, claim), claimEmployee.claim)
    }),
    disabled: true,
    name: "s1308",
    type: "text",
    size: "sm"
  }))));
};